import { useTranslation } from 'react-i18next';

import { useSectionAccess } from '@/shared/navigation/useSectionAccess';
import { AccessRestricted, PageContainer } from '@/shared/ui';

/**
 * The portal's single refusal screen, wired to the session's own way onward.
 *
 * <p>Every route-level refusal renders this — the two guards and the index redirects alike — so a
 * "not yours" looks the same wherever it is met and always offers a section the user can actually
 * open. Keeping the page shell and the fallback lookup in one place is what stops the three call
 * sites drifting into three slightly different dead ends, which is how the ~20 hand-copied refusals
 * this replaced came about.
 */
export function AccessRefusal() {
  const { t } = useTranslation('common');
  const { fallback } = useSectionAccess();

  return (
    <PageContainer title={t('accessRestricted.title')}>
      <AccessRestricted fallbackPath={fallback?.path} fallbackLabelKey={fallback?.labelKey} />
    </PageContainer>
  );
}
